<div class="dialog-content">
  <div class="dialog-header">
    <span class="dialog-heading">
      {{ isEdit ? 'Uredi pravilo za stavke' : 'Novo pravilo za stavke' }}
    </span>
    <mat-icon class="h-24-w-24 cursor-pointer" mat-dialog-close>close</mat-icon>
  </div>

  <p class="hint">
    Označite polja koja moraju odgovarati stavci izvoda i odaberite konto i/ili
    partnera koji se dodjeljuju. Opis_1 mora biti jednak; za Opis_2, Opis_3 i
    svrhu dovoljno je da stavka sadrži uneseni tekst. Pravilo važi samo za račun
    <strong>{{ data.companyAccount }}</strong>.
  </p>

  <div class="conditions">
    <div class="condition-row" *ngFor="let c of conditions">
      <mat-checkbox
        color="primary"
        [(ngModel)]="useAsCondition[c.key]"
        [disabled]="!values[c.key].trim()"
        [matTooltip]="'Koristi ' + c.label + ' kao uslov pravila'"
      ></mat-checkbox>
      <mat-form-field appearance="outline" [hideRequiredMarker]="true" class="condition-field">
        <mat-label>{{ c.label }}</mat-label>
        <input matInput [(ngModel)]="values[c.key]" [name]="c.key" />
      </mat-form-field>
    </div>
  </div>

  <div class="assignments">
    <mat-form-field appearance="outline" [hideRequiredMarker]="true">
      <mat-label>Konto</mat-label>
      <input
        #kontoInput
        matInput
        name="konto"
        [matAutocomplete]="kontoAuto"
        [(ngModel)]="konto"
        placeholder="Odaberite konto"
      />
      <mat-autocomplete #kontoAuto="matAutocomplete" [displayWith]="kontoDisplayFn">
        <mat-option
          *ngFor="let a of filteredAccounts(kontoInput.value)"
          [value]="a.konto"
          [matTooltip]="a.konto + ' – ' + a.nazivKonta"
          matTooltipPosition="right"
        >
          {{ a.konto }} – {{ a.nazivKonta }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" [hideRequiredMarker]="true">
      <mat-label>Partner (šifra)</mat-label>
      <input
        #partnerInput
        matInput
        name="partnerCode"
        [matAutocomplete]="partnerAuto"
        [(ngModel)]="partnerCode"
        placeholder="Odaberite partnera"
      />
      <mat-autocomplete #partnerAuto="matAutocomplete" [displayWith]="partnerDisplayFn">
        <mat-option
          *ngFor="let p of filteredPartners(partnerInput.value)"
          [value]="p.code"
          [matTooltip]="p.code + ' – ' + (p.companyName || '') + (p.idNumber ? ' (' + p.idNumber + ')' : '')"
          matTooltipPosition="right"
        >
          {{ p.code }} – {{ p.companyName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" [hideRequiredMarker]="true">
      <mat-label>ID broj partnera</mat-label>
      <input matInput name="partnerIdBroj" [value]="partnerIdBroj" readonly />
    </mat-form-field>
  </div>

  <div class="action-button">
    <button class="secondary-button" mat-dialog-close type="button">Otkaži</button>
    <button
      class="primary-button"
      [disabled]="!isValid || saving"
      [promiseBtn]="saving"
      (click)="save()"
    >
      <mat-icon>save</mat-icon>
      <span class="ml-8">Snimi</span>
    </button>
  </div>
</div>
